import { Component, type ErrorInfo, type ReactNode } from 'react';

type Props={children:ReactNode};
type State={failed:boolean};

export class ErrorBoundary extends Component<Props,State>{
 state:State={failed:false};

 static getDerivedStateFromError(){return {failed:true}}

 componentDidCatch(error:Error,info:ErrorInfo){
   console.error('[Xynysys UI error]',error,info);
 }

 render(){
   if(this.state.failed){
     return <main className="fatal-error-page">
       <div className="fatal-error-mark">XY / 500</div>
       <div className="fatal-error-code">500</div>
       <h1>Something interrupted the experience.</h1>
       <p>The interface hit an unexpected client-side error. Reload the page or return to the homepage.</p>
       <div className="fatal-error-actions">
         <button onClick={()=>location.reload()}>Reload page ↻</button>
         <a href="/">Return home ↗</a>
       </div>
     </main>;
   }
   return this.props.children;
 }
}
